"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"

export default function ScrollHandler() {
  const pathname = usePathname()

  useEffect(() => {
    // Prevent back/forward cache issues
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        window.location.reload()
      }
    }

    const handleBeforeUnload = () => {
      // Clean up any ongoing operations
      window.scrollTo(0, 0)
    }

    window.addEventListener("pageshow", handlePageShow)
    window.addEventListener("beforeunload", handleBeforeUnload)

    return () => {
      window.removeEventListener("pageshow", handlePageShow)
      window.removeEventListener("beforeunload", handleBeforeUnload)
    }
  }, [])

  useEffect(() => {
    // Smooth scroll to top on route change
    window.scrollTo({ top: 0, behavior: "smooth" })
  }, [pathname])

  return null
}
